import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})

export interface InviteInfo {
  email: string
  name: string
  purpose: 'invite' | 'reset'
}

interface ApiResponse<T> {
  success: boolean
  data?: T
  error?: string
}

function parseError(err: unknown, fallback: string): Error {
  const ax = err as { response?: { data?: { error?: string } }; message?: string }
  return new Error(ax.response?.data?.error || ax.message || fallback)
}

export async function validateInviteToken(token: string): Promise<InviteInfo> {
  try {
    const res = await api.get<ApiResponse<InviteInfo>>('/auth/invite', {
      params: { token },
    })
    if (!res.data.success || !res.data.data) {
      throw new Error(res.data.error || 'Ugyldigt link')
    }
    return res.data.data
  } catch (e) {
    throw parseError(e, 'Ugyldigt link')
  }
}

export async function acceptInvite(
  token: string,
  password: string
): Promise<void> {
  try {
    const res = await api.post<ApiResponse<unknown>>('/auth/invite/accept', {
      token,
      password,
    })
    if (!res.data.success) {
      throw new Error(res.data.error || 'Kunne ikke gemme adgangskode')
    }
  } catch (e) {
    throw parseError(e, 'Kunne ikke gemme adgangskode')
  }
}
